// src/components/layout/RelatorioMensalTabelas.js
//
// Renderiza as duas tabelas do relatório mensal (Crescimento + Frequência
// por dia), a partir do resultado de `montarCrescimentoDoMes`
// (src/firebase/relatorios.js). JSX extraído de RelatorioMensal.js pra
// poder ser reaproveitado também em HistoricoRelatorios.js — antes só
// existia para o mês atual, sem forma de ver meses passados.

import style from '../pages/Geral/geral.module.css'

export default function RelatorioMensalTabelas({ diasOrdenados, crescimento, mes }) {
  if (!diasOrdenados || diasOrdenados.length < 1) return null

  return (
    <>
      <h3>Controle de Crescimento - Mês: {mes < 9 ? '0' + mes : mes}</h3>
      <table className={`${style.tabela}`}>
        <thead>
          <tr>
            <th>F. Etária</th>
            <th>Nº Classes</th>
            <th>Nº Professores</th>
            <th>Nº Matriculados Inicio do Mês</th>
            <th>Nº Matriculados Fim do Mês</th>
            <th>Nº Visitantes</th>
          </tr>
        </thead>
        <tbody>
          {crescimento &&
            crescimento.map((item, index) => {
              return (
                <>
                  {item.qtd != 0 && (
                    <tr key={index}>
                      <td style={{ width: '100%', textAlign: 'center' }}>{item.nome}</td>
                      <td data-label=' Nº Classes'>{item.qtd}</td>
                      <td data-label=' Nº Professores'>{item.qtdProf}</td>
                      <td data-label=' Nº Matriculados Início do Mês'>{item.qtdAlunos}</td>
                      <td data-label=' Nº Matriculados Fim do Mês'>{item.qtdAlunosFim}</td>
                      <td data-label=' Nº Visitantes Mês'>{item.qtdVisit}</td>
                    </tr>
                  )}
                </>
              )
            })}
        </tbody>
      </table>

      <h3>Controle de Frequência de Aluno por Classe</h3>
      <table className={`${style.tabela}`}>
        <thead>
          <tr>
            <th>Data</th>
            <th>F. Etária</th>
            <th>Professores Presentes</th>
            <th>Professores Ausentes</th>
            <th>Nº Presentes</th>
            <th>Nº Ausentes</th>
            <th>Ofertas</th>
          </tr>
        </thead>
        <tbody>
          {diasOrdenados.map((dias, indexDias) => {
            return (
              <>
                <p>{`${dias.data.dia < 9 ? '0' + dias.data.dia : dias.data.dia}/${dias.data.mes < 9 ? '0' + dias.data.mes : dias.data.mes}/${dias.data.ano}`}</p>
                {dias.progressao.map((item, index) => {
                  return (
                    <>
                      {item.qtd != 0 && (
                        <tr key={index + '-' + indexDias}>
                          <td></td>
                          <td style={{ width: '100%', textAlign: 'center' }}>{item.nome}</td>
                          <td data-label='Professores Presentes'>{item.prof}</td>
                          <td data-label='Professores Ausentes'>{item.qtdProf - item.prof}</td>
                          <td data-label='Presenças'>{item.qtdPresent}</td>
                          <td data-label='Ausências'>{item.qtdAlunos - item.qtdPresent}</td>
                          {item.nome == 'Total' && (
                            <>
                              <td data-label='Ofertas'>{Number(dias.ofertas).toFixed(2)}</td>
                              <td data-label='Oferta Professores'>{Number(dias.ofertaProf).toFixed(2)}</td>
                            </>
                          )}
                        </tr>
                      )}
                    </>
                  )
                })}
              </>
            )
          })}
        </tbody>
      </table>
    </>
  )
}
